export default "__VITE_ASSET__T$KUh3_s__"